export interface MachineMaintenanceTicket {
  _id?: string;
  id?: string;
  status?: string;
  stamp?: string | Date;
  stamp_end?: string | Date;
  closed_at?: string | Date;
  maintenance_type?: string;
  message?: string;
  close_message?: string;
  message_done?: string;
  next_maintenance_at?: string | number;
}

function toDate(value?: string | Date | null): Date | null {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function calculateMaintenanceDowntimeSeconds(
  tickets: MachineMaintenanceTicket[],
  windowStart: Date,
  windowEnd: Date = new Date()
): number {
  if (!(windowStart instanceof Date) || !(windowEnd instanceof Date) || windowEnd <= windowStart) return 0;

  return (tickets || []).reduce((total, ticket) => {
    const start = toDate(ticket.stamp);
    let end = toDate(ticket.stamp_end || ticket.closed_at);
    if (!start) return total;
    if (!end || ticket.status === 'aberto') end = windowEnd;

    const clippedStart = new Date(Math.max(start.getTime(), windowStart.getTime()));
    const clippedEnd = new Date(Math.min(end.getTime(), windowEnd.getTime()));
    if (clippedEnd <= clippedStart) return total;
    return total + Math.round((clippedEnd.getTime() - clippedStart.getTime()) / 1000);
  }, 0);
}

export function isMachineInOpenMaintenance(tickets: MachineMaintenanceTicket[], machineId?: string | null): boolean {
  if (!machineId) return false;
  return (tickets || []).some((ticket) => ticket.id === machineId && ticket.status === 'aberto' && !ticket.stamp_end && !ticket.closed_at);
}

export function summarizeMaintenanceTicket(ticket: MachineMaintenanceTicket): string {
  const parts = [
    ticket.id || 'máquina não informada',
    ticket.maintenance_type || 'tipo não informado',
    ticket.message || ticket.close_message || ticket.message_done || 'sem descrição',
  ];
  if (ticket.next_maintenance_at !== undefined && ticket.next_maintenance_at !== '') {
    parts.push(`próxima: ${ticket.next_maintenance_at}`);
  }
  return parts.join(' • ');
}
